import React from 'react'

interface CanvasNoteIconProps {
  size?: number
  className?: string
}

/**
 * "Notiz platzieren"-Icon der Projekt-Canvas-Toolbar (Figma: `Icon / Sticker`,
 * Node `4940:376214` in `btn Canvas Toolbar Thought` 4916:265191).
 * Zweifarbig und bewusst hart kodiert: Gelb steht für die Notiz-Typ selbst
 * (wie `CanvasMemoIcon` für die Notiz) — das ist keine UI-Semantik, die ein
 * Theme-Token tragen würde. Gleiche Konvention wie `SproutIcon`.
 *
 * Zeichnet direkt in der 24er-Box; der frühere `translate(2.25 2.25)` um einen
 * 19.5×19.5-Export entfällt, weil Figma das Icon inzwischen randfüllend anlegt.
 *
 * Die beiden Augen sind ein eigener Pfad mit `strokeWidth 2.63` — als
 * Null-Längen-Segmente mit runder Kappe ergeben sie die Punkte. Früher waren
 * es Mini-Segmente in der 1.5er-Kontur, wodurch sie deutlich kleiner ausfielen.
 *
 * Eselsohr, Mund und Augen sind eigene Teile, damit sie sich beim Überfahren einzeln bewegen
 * (#315, `_toolbarIconMotion.scss`) — dieselbe Zeichnung, nur in Stücken.
 */
export const CanvasNoteIcon: React.FC<CanvasNoteIconProps> = ({ size = 24, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['canvas-note-icon', className].filter(Boolean).join(' ')}
  >
    <path
      d="M16.0858 3.58579C15.7107 3.21071 15.202 3 14.6716 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 20.1 3.9 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V9.32843C21 8.79799 20.7893 8.28929 20.4142 7.91421L16.0858 3.58579Z"
      fill="#FFF9AE"
    />
    <g className="canvas-note-icon__ear" stroke="#938A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 3V7C14 7.53043 14.2107 8.03914 14.5858 8.41421C14.9609 8.78929 15.4696 9 16 9H20" fill="#FFF9AE" stroke="none" />
      <path d="M14 3V7C14 7.53043 14.2107 8.03914 14.5858 8.41421C14.9609 8.78929 15.4696 9 16 9H20" />
    </g>
    <path
      d="M5 3H14.6716C15.202 3 15.7107 3.21071 16.0858 3.58579L20.4142 7.91421C20.7893 8.28929 21 8.79799 21 9.32843V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C3.9 21 3 20.1 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3Z"
      stroke="#938A1A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g className="canvas-note-icon__mouth" stroke="#938A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 16C10 16 10.8 17 12 17C13.3 17 14 16 14 16" fill="#FFF9AE" stroke="none" />
      <path d="M10 16C10 16 10.8 17 12 17C13.3 17 14 16 14 16" />
    </g>
    <path className="canvas-note-icon__eye-left" d="M7.99 12H8" stroke="#938A1A" strokeWidth="2.63" strokeLinecap="round" strokeLinejoin="round" />
    <path className="canvas-note-icon__eye-right" d="M15.99 12H16" stroke="#938A1A" strokeWidth="2.63" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
